import apiService from "../ApiService";

const endpoint = "/states";

/**
 * Get all states
 */
export const getStates = async () => {
    try {
        const response = await apiService.getAll(endpoint);
        return response;
    } catch (error) {
        console.error("Error fetching states:", error);
        throw error;
    }
};

/**
 * Get state by ID
 */
export const getStateById = async (id) => {
    try {
        const response = await apiService.getById(endpoint, id);
        return response;
    } catch (error) {
        console.error(`Error fetching state with ID ${id}:`, error);
        throw error;
    }
};

/**
 * Create state
 */
export const createState = async (data) => {
    try {
        const response = await apiService.create(endpoint, data);
        return response;
    } catch (error) {
        console.error("Error creating state:", error);
        throw error;
    }
};

/**
 * Update state
 */
export const updateState = async (id, data) => {
    try {
        const response = await apiService.update(endpoint, id, data);
        return response;
    } catch (error) {
        console.error("Error updating state:", error);
        throw error;
    }
};

/**
 * Delete state
 */
export const deleteState = async (id) => {
    try {
        const response = await apiService.remove(endpoint, id);
        return response;
    } catch (error) {
        console.error("Error deleting state:", error);
        throw error;
    }
};
